const INTL_LOCALE_OVERRIDES = {
    es_LA: 'es-419',
};
const DAYJS_LOCALE_OVERRIDES = {
    pt_BR: 'pt-br',
    zh_CN: 'zh-cn',
};
export function toIntlLocale(appLocale) {
    var _a;
    return (_a = INTL_LOCALE_OVERRIDES[appLocale]) !== null && _a !== void 0 ? _a : appLocale.replace('_', '-');
}
export function toDayjsLocale(appLocale) {
    var _a;
    return (_a = DAYJS_LOCALE_OVERRIDES[appLocale]) !== null && _a !== void 0 ? _a : appLocale.split(/[-_]/)[0].toLowerCase();
}
export function resolveActiveDateLocales(options) {
    if (!options.localizationEnabled) {
        return {
            intlLocale: undefined,
            dayjsLocale: 'en',
        };
    }
    return {
        intlLocale: toIntlLocale(options.appLocale),
        dayjsLocale: toDayjsLocale(options.appLocale),
    };
}
